module.exports = __webpack_public_path__ + "static/media/menu-credit-card-management.33684438.svg";